import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  number: 1,
  title: 'Cómo No Dejarte Cagar en la Carnicería',
  subtitle: 'Para que el carnicero no te cague más.',
  bullets: ['Cómo elegir cualquier corte en segundos con vista, tacto y olfato', 'Las trampas del mostrador que te cuestan plata cada fin de semana', 'Las preguntas exactas que hacen que el carnicero te respete', 'La anatomía de la vaca explicada para el que no estudió veterinaria']
}, {
  number: 2,
  title: 'Asado de Primera con Bolsillo Flaco',
  subtitle: 'Los cortes baratos que saben a caro cuando sabés cómo tratarlos.',
  bullets: ['8 cortes económicos con su protocolo de transformación completo', 'Marucha, tortuguita, azotillo: cómo convertirlos en algo que la gente recuerda', 'La tabla de merma real: cuánto pagás por lo que realmente te comés', 'Cómo armar un asado de diez con presupuesto de cinco']
}, {
  number: 3,
  title: 'El Corte que Hace la Diferencia',
  subtitle: 'El corte correcto después de la cocción perfecta.',
  bullets: ['Qué es la fibra muscular y por qué cortarla mal arruina todo el trabajo', 'El protocolo de corte para vacío, entraña, costillar y matambre', 'El reposo: el paso que casi todos se saltan y que cambia todo', 'El test de la mano sin termómetro: el método del campo de verdad']
}, {
  number: 4,
  title: 'Cuánto Comprar Sin Volverse Loco',
  subtitle: 'Nunca más el pánico del domingo a las 11 de la mañana.',
  bullets: ['Los gramajes exactos por tipo de comensal argentino', 'El mix de cortes ideal para no gastar de más ni quedar corto', 'La calculadora de presupuesto paso a paso', 'Qué hacer cuando llegaron más personas de las esperadas']
}, {
  number: 5,
  title: 'Dominar el Fuego de Una Vez',
  subtitle: 'El fuego no es el enemigo. La ignorancia sobre el fuego sí.',
  bullets: ['La física del calor aplicada a la parrilla sin tecnicismos', 'El Método Cero Humo: encendido perfecto sin líquido inflamable', 'La lectura de la brasa: color, ceniza y el test de la mano calibrado', 'Las leñas argentinas y cuál usar según lo que tenés en el fuego', 'Distribución por zonas: la herramienta que los asadores de campo dominaban sin saberlo']
}, {
  number: 6,
  title: 'Que Todo Llegue Junto y en Punto',
  subtitle: 'Para que todo llegue a la mesa al mismo tiempo y en punto.',
  bullets: ['La ingeniería inversa del asado: empezás desde la hora de servicio hacia atrás', 'Los tiempos reales de cada corte argentino: tabla completa', 'Cuatro cronogramas listos para usar según la ocasión', 'Cómo manejar el kilombo cuando el plan se va al diablo']
}, {
  number: 7,
  title: 'La Sal, el Chimi y Todo lo que Va Encima',
  subtitle: 'La sal, la salmuera y el chimichurri que hacen la diferencia real.',
  bullets: ['La zona prohibida del salado que seca la carne sin que te des cuenta', 'Las cinco salmueras centenarias de campo con receta y protocolo completo', 'El chimichurri de 72 horas: el que probás una vez y no volvés al otro nunca más', 'La criolla, las marinadas y cuándo usar cada cosa']
}, {
  number: 8,
  title: 'Las Técnicas del Campo que se Están Perdiendo',
  subtitle: 'Las técnicas que los gauchos usaron por generaciones y que casi nadie conoce.',
  bullets: ['El asado a la cruz completo: equipamiento, animal y cronograma', 'El horno de barro y el lechón de piel perfecta', 'La paila de campo: mollejas y chinchulines como los hacían en las estancias', 'El entierro patagónico: el curanto con piedras calientes', 'La parrilla invertida para costillares extremos de más de 5 kg']
}, {
  number: 9,
  title: 'Cuando Algo Sale Mal (y Cómo Zafar)',
  subtitle: 'Para cuando algo se va al carajo y necesitás solución ya.',
  bullets: ['Los 15 problemas más frecuentes con su protocolo de rescate paso a paso', 'Carne arrebatada, seca, dura o cruda al centro: qué hacer en cada caso', 'Brasa apagada, llamas, viento y lluvia: el plan B siempre listo', 'Las frases exactas para que nadie note que hubo un problema']
}, {
  number: 10,
  title: 'Los Machetes del Asador',
  subtitle: 'Para consultar antes, durante y después de cada asado.',
  bullets: ['Glosario completo del asado argentino', 'Tabla de temperaturas internas por corte', 'Checklists de compra, encendido, cocción y servicio', 'Plantillas de cronograma para personalizar']
}];
export function TomosList() {
  return <section className="py-20 bg-zinc-950" data-id="element-276">
      <div className="container mx-auto px-4" data-id="element-277">
        <div className="max-w-4xl mx-auto" data-id="element-278">
          <div className="space-y-8 mb-16" data-id="element-279">
            {tomos.map(tomo => <div key={tomo.number} className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden flex flex-col md:flex-row" data-id="element-280">
                <div className="bg-zinc-950 p-6 md:w-48 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-zinc-800" data-id="element-281">
                  <BookOpenIcon className="w-12 h-12 text-amber-500 mb-3" data-id="element-282" />
                  <span className="text-zinc-500 font-bold tracking-widest uppercase text-sm" data-id="element-283">
                    TOMO {tomo.number}
                  </span>
                </div>
                <div className="p-6 md:p-8 flex-1" data-id="element-284">
                  <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-285">
                    {tomo.title}
                  </h3>
                  <h4 className="text-amber-500 font-medium mb-4 italic" data-id="element-286">
                    {tomo.subtitle}
                  </h4>
                  <ul className="space-y-3" data-id="element-287">
                    {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start text-zinc-400 text-sm md:text-base" data-id="element-288">
                        <span className="text-amber-500 mr-3 mt-1" data-id="element-289">•</span>
                        <span data-id="element-290">{bullet}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-291">
            <CTAButton data-id="element-292" />
          </div>
        </div>
      </div>
    </section>;
}